import { ButtonBase } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export default function SamlButton({ onClick }) {
  const { t } = useTranslation("components");

  return (
    <WhiteButton data-testid="login__use-own-domain-btn" onClick={onClick}>
      {t("landing.useOwnDomain")}
    </WhiteButton>
  );
}

const WhiteButton = styled(ButtonBase)`
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  display: grid;
  font-family: "Roboto", sans-serif;
  font-size: 0.9375rem;
  font-weight: 500;
  padding: 9px 22px;
  width: 100%;
`;
